import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Context } from '../context';
import { ApiService } from './api.service';
import { AppEvents } from './app.events';
import { PlanService } from './plan.service';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private api: ApiService,
    private settings: SettingsService,
    private translate: TranslateService,
    private appEvents: AppEvents,
    private planService: PlanService
  ) { }

  async init() {
    Context.reset();

    Context.authToken = await this.settings.authToken();
    if (Context.authToken) {
      Context.user = await this.settings.user();
      if (Context.user?.language != null) {
        this.translate.setDefaultLang(Context.user.language);
      }

      await this.refreshUser();
      await this.planService.syncPlan();

      this.appEvents.signedIn$.next(Context.user);
    }
  }

  private async refreshUser() {
    try {
      Context.user = await this.api.currentUser();
      await this.settings.user(Context.user);
    } catch (e) { }
  }

  async verify(code: string) {
    const rsp = await this.api.authenticate(code);

    await this.setToken(rsp.token);
  }

  async setToken(token: string) {
    await this.settings.authToken(token);

    Context.authToken = token;

    Context.user = await this.api.currentUser();
    await this.settings.user(Context.user);
    await this.planService.syncPlan();

    this.appEvents.signedIn$.next(Context.user);
  }

  async signOut() {
    Context.reset();
    localStorage.clear()
    await this.settings.reset();
    this.appEvents.signedOut$.next();
  }
}
